import VideoCommentsToggle from './VideoCommentsToggle'

export default VideoCommentsToggle
// eslint-disable-next-line import/export
export * from './VideoCommentsToggle'
